import { parseElemezHostname } from './url';

export const brands = ['panasonic', 'elemez', 'brady', 'peaktech', 'computacenter'] as const;

export type Brand = typeof brands[number];

export const DEFAULT_BRAND: Brand = 'elemez';

//** Map of hostname prefixes that determine brand if systemConfig.branding is not set */
const brandHostPrefixes: { [key: string]: Brand } = {
  'panasonic': 'panasonic',
  'peaktech': 'peaktech',
  'computacenter': 'computacenter',
  'brady': 'brady',
  'honeywell': 'brady',
  'firstenergy': 'panasonic'
};

export const getCurrentBrand = (): Brand => {
  const cypressWindow: any = (window as any);
  if (cypressWindow.Cypress && cypressWindow.brand) {
    return cypressWindow.brand;
  }

  const [brand] = parseElemezHostname();
  if (!brand) {
    return DEFAULT_BRAND;
  }

  return brandHostPrefixes[brand] || brandHostPrefixes[brand.split('-')[0]] || DEFAULT_BRAND;
};
